<template>
    <layout-admin >
        <div slot="sidebar">
            <admin-datalist  :active="edit" link="/fa/v1/agencies" @itemClick="itemSelected" ref="datalist"/>
        </div>
        <div slot="content">
            <div v-if="showForm">

                <!-- Form -->
                <b-navbar class="px-0 pt-3" type="light" variant="light">
                    <b-navbar-brand href="#">{{title}}</b-navbar-brand>
                    <button-delete title="حذف" class="ml-3 mr-auto "
                                  link="/fa/v1/agencies"
                                  @deleted="itemDeleted"
                                  v-show="edit" :id="edit"/>
                    <b-button class="btn-outline-primary " @click="backToPageClick">بازگشت</b-button>

                </b-navbar>
                <b-card no-body class="form-card mt-2">
                    <b-tabs card class="">
                        <b-tab title="مشخصات" active>
                            <form-agencie :edit="edit"
                                       @created="itemCreated"
                                       @updated="itemUpdated"/>

                        </b-tab>
                    </b-tabs>
                </b-card>
            </div>
            <div v-else>
                <!-- Dashboard -->
                <b-row>
                    <b-col>

                        <b-navbar class="px-0 pt-3 pb-0" type="light" variant="light">
                            <b-navbar-brand href="#">{{title}}</b-navbar-brand>
                            <b-button class="btn-outline-primary  mr-auto " @click="newItemClick">افزودن</b-button>
                        </b-navbar>


                    </b-col>
                    <b-col class="pr-lg-0">
                        <datachart class=" mt-3" url="/fa/v1/agencies/chart"  ref="datachart"/>
                    </b-col>
                </b-row>





            </div>
        </div>
    </layout-admin>

</template>

<script>
import MainLayout from "../layouts/MainLayout";
import Datachart from "../charts/Datachart";
import ButtonDelete from "../ButtonDelete";
import Pagination from "../Pagination";
import AdminDatalist from "../AdminDatalist";
import LayoutAdmin from "../layouts/LayoutAdmin";
import StateTotal from "../StateTotal";
import mixinPage from "../../mixins/mixinPage";
import FormAgencie from "../forms/FormAgencie";

export default {
  mixins: [mixinPage],
  components: {
    FormAgencie,
    StateTotal,
    LayoutAdmin,
    MainLayout,
    Datachart,
    AdminDatalist,
    Pagination,
    ButtonDelete
  },
  name: "PageAgencie",
  metaInfo: {
    title: "نمایندگان"
  },
  data: function() {
    return {
      title: "نمایندگان",
      totalLink: "/fa/v1/agencies/total",
      total: {
        admins: 0
      }
    };
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/pages/PageAgencie.vue